export default (state = true, action: { type: string, payload :boolean }) => {
  switch (action.type) {
    case "DISABLE_ADMIN_TAB":
      return action.payload;
    default:
      return state;
  }
}